import HomeMaintenancePage from './modules/home-maintenance/HomeMaintenancePage.svelte';

const app = new HomeMaintenancePage({
  target: document.getElementById('home-maintenance-page'),
  props: {
    pageConfig: window['pageConfig'],
  },
});

export default app;
